import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, formatError } from "@/lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT") : "—");

const RequestRow = ({ r, onToggle }) => {
  const scores = [...(Array.isArray(r.results) ? r.results : [])].sort((a, b) => b.score - a.score);
  return (
    <div data-testid={`softskill-request-${r.id}`} className={`space-y-3 p-4 ${r.status === "contattato" ? "opacity-60" : ""}`}>
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="min-w-0">
          <p className="font-semibold">{r.name} <span className="font-mono text-xs text-[#98bfa2]">· {r.overall ?? 0}/100</span></p>
          <p className="font-mono text-xs text-[#a3b1aa]">
            <a href={`mailto:${r.email}`} className="hover:text-[#c4dcca]">{r.email}</a>
            {r.phone && <> · <a href={`tel:${r.phone}`} className="hover:text-[#c4dcca]">{r.phone}</a></>} · {fmt(r.created_at)}
          </p>
        </div>
        <label className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-[#a3b1aa]">
          <Switch data-testid={`softskill-contacted-${r.id}`} checked={r.status === "contattato"} onCheckedChange={(v) => onToggle(r, v)} /> Contattato
        </label>
      </div>
      {r.message && <p className="text-sm italic text-[#a3b1aa]">«{r.message}»</p>}
      <div className="flex flex-wrap gap-2">
        {scores.map((s) => <span key={s.key} className="border border-white/10 px-2 py-1 font-mono text-[11px] text-[#a3b1aa]">{s.name} {s.score}</span>)}
      </div>
    </div>
  );
};

export const SoftSkillsPanel = () => {
  const [items, setItems] = useState([]);
  const load = () => {
    api.get("/admin/softskill-requests").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const toggle = async (r, done) => {
    try {
      await api.patch(`/admin/softskill-requests/${r.id}`, { status: done ? "contattato" : "da_contattare" });
      load();
    } catch (e) {
      toast.error(formatError(e));
    }
  };

  return (
    <div className="space-y-6" data-testid="softskills-panel">
      <p className="max-w-2xl text-sm text-[#a3b1aa]">
        Qui trovi chi ha fatto il check-up Soft Skills e ti ha inviato i risultati per una consulenza. Ricevi anche un'email per ogni nuova richiesta.
      </p>
      {items.length === 0 && <p data-testid="softskills-empty" className="text-sm text-[#a3b1aa]">Nessuna richiesta per ora.</p>}
      <div className="divide-y divide-white/5 border border-[rgba(152,191,162,0.15)]">{items.map((r) => <RequestRow key={r.id} r={r} onToggle={toggle} />)}</div>
    </div>
  );
};
